export const fromFine = (o) => {
    const [w, x, y, z] = o.quaternion();
    return { w, x, y, z };
};
